import store from "@/store";
// import warningTimeout from "@/providers/warningTimeout";
// import lockScreenTimeout from "@/providers/lockScreenTimeout";
import { setStorageData, getStorageData } from "@/utils/storage";
import { aclRoute } from "@/components/acl";

import isRedirectToLogin from "./rules/isRedirectToLogin";
import isRedirectToLock from "./rules/isRedirectToLock";
import isRouteWithTimeout from "./rules/isRouteWithTimeout";
// import isTimeOutQualifiedly from "./rules/isTimeOutQualifiable";
import isSameRevision from "./rules/isSameRevision";

const STORAGE_USER_KEY = "user";


const ignoredRouteForRedirect = [
  "system@login",
  "system@logout",
  "system@lock",
  "system@resetPassword"
];

const guardRoutes = (to, __, next) => {
  store.dispatch('errorStore/clearErrors',{root:true});

  if (!isSameRevision()) {
    store.dispatch('systemStore/setRevision',{root:true});
    // window.location.reload();
  }

  const user = getStorageData(STORAGE_USER_KEY);

  const shouldRedirectToLogin = isRedirectToLogin(to, user);
  const routeWithTimeout = isRouteWithTimeout(to);
  // const shouldEnableTimeOut = isTimeOutQualifiedly(user);
  const shouldRedirectToLock = routeWithTimeout && isRedirectToLock(user);

  if (shouldRedirectToLogin) {
    let redirect = { path: to.path };

    if (ignoredRouteForRedirect.includes(to.name)) {
      redirect = { name: 'home'};
    }
    
    setStorageData("intended", redirect);
    return next({ name: "system@login" });
  }

  if (shouldRedirectToLock) {
    return next({ name: "system@lock" });
  }

  // if (routeWithTimeout && shouldEnableTimeOut) {
  //   user.isLockEnabled = true;
  //   setStorageData(STORAGE_USER_KEY, user);
  //   lockScreenTimeout(warningTimeout);
  // }

  aclRoute(to, next);

  return next();
};

export default guardRoutes;
